import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const CancellationPolicy = lazy(() => import("@/pages/policies/CancellationPolicy"));

export const Route = createFileRoute("/_public/cancellation-policy")({
  component: CancellationPolicy,
});
